import { useState } from 'react';

import { ModalButtons } from '@collab/organisms';
import { formatDate, formatTime } from '@collab/utils/formatters';

import { VolvoIdToken } from 'libs/volvoId/models';
import SecretText from 'molecules/SecretText';

export const title = 'Access token for testing';

const AccessTokenModal: React.FC<{
  apiDisplayName: string;
  tokenName: string;
  token: VolvoIdToken;
  onClose: () => void;
}> = ({ token, tokenName, apiDisplayName, onClose }) => (
  <>
    <p className="text-secondary pb-24">
      This {tokenName} test access token works for the{' '}
      <strong>{apiDisplayName}</strong>. Copy and use it in your code to test
      your application.
    </p>
    <SecretSection token={token.accessToken} isLoading={false} />
    <div className="text-secondary flex-col pt-8">
      <small>
        The access token has a short lifespan (until{' '}
        {formatTime(token.expiresOnRaw)} {todayOrTomorrow(token.expiresOnRaw)}).
      </small>
      <small>You can’t view this access token again.</small>
    </div>
    <ModalButtons
      closeButton={{
        onClick: onClose,
        text: 'Close',
      }}
    />
  </>
);

const SecretSection: React.FC<{
  token: string;
  isLoading: boolean;
}> = ({ token, isLoading }) => {
  const [showSecret, setShowSecret] = useState(false);

  return (
    <SecretText
      text={token}
      showText={showSecret}
      onToggleShow={() => setShowSecret(!showSecret)}
      isLoading={isLoading}
    />
  );
};

const todayOrTomorrow = (date: string): string => {
  const today = new Date().toString();

  return formatDate(date) === formatDate(today) ? 'today' : 'tomorrow';
};

export default AccessTokenModal;
